//
import { RDashboardLayout } from "@/components/reusable_components/layouts"
import Routes from "./Routes"

//
export default [
    {
        path: "/", 
        component: RDashboardLayout, 
        children: Routes,
    },
]